import React from 'react';
import { Loader2, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function ActiveAgentBar({ agent, running = false }) {
  const hasAgent = Boolean(agent?.title || agent?.agent);
  if (!hasAgent && !running) return null;

  const title = hasAgent
    ? (agent.title || agent.agent || 'Agent')
    : 'Architect Agent';
  const nextPlan = hasAgent
    ? (agent.next_plan || agent.nextPlan || '')
    : (running ? 'Starting build pipeline…' : '');
  const fixing = hasAgent ? (agent.fixing || '') : '';

  return (
    <div
      className="shrink-0 border-b border-violet-500/15 bg-violet-500/[0.06] px-4 py-2.5"
      data-testid="app-builder-active-agent-bar"
    >
      <div className="flex items-start gap-2.5">
        <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-violet-600/30">
          {running ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin text-violet-200" />
          ) : (
            <Sparkles className="h-3.5 w-3.5 text-violet-200" />
          )}
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-violet-300">
            Now handling
          </p>
          <p className={cn('text-sm font-medium text-zinc-100', running && 'text-violet-100')}>{title}</p>
          {fixing ? (
            <p className="text-xs leading-5 text-amber-200/90">
              <span className="font-medium text-amber-300">Fixing: </span>
              {fixing}
            </p>
          ) : null}
          {nextPlan ? (
            <p className="text-xs leading-5 text-zinc-400">
              <span className="font-medium text-zinc-300">Next: </span>
              {nextPlan}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
